<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11iSXYO/tc-custom/9780830863082.jpg?1696025623429" alt="This image is the cover for the book David, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">David, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>Who are your role models? The world desperately needs role models today—people who are fully human yet who exceed human expectations and point others toward God. David is such a role model. His struggles with sin are infamous, and the Psalms reveal his anguish and doubts. Yet he is also described as "a man after God's own heart"—the champion of Israel. In this twelve-session LifeGuide® Bible Study, Jack Kuhatschek introduces you to David the servant and the leader, the sinner and the redeemed, the man and the instrument of God's creative purposes. As you explore David's tumultous story, you too will discover what it means to have a passionate heart for God. For over three decades LifeGuide Bible Studies have provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies. <strong>PDF download with a single-user license; available from InterVarsity Press and other resellers.</strong> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Kuhatschek
      </h2>
      
      <p class="authorDescription body article"><p>Jack Kuhatschek was formerly executive vice president and publisher for Baker Publishing Group in Grand Rapids, Michigan. He is the author of many Bible study guides and the books <em>Applying the Bible</em> and <em>The Superman Syndrome</em>. He and his wife, Sandy, currently live in Deland, Florida.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a06c4350